/* eslint-disable prettier/prettier */
import { TranslationMap } from './default'

export const ko: TranslationMap = {
  "accountstatus.Active": "활성화",
  "accountstatus.Inactive": "비활성화",
  "accountstatus.Terminated": "종료 됨",
  "additionalitems.title": "추가 항목",
  "cart.addtocart": "장바구니 담기",
  "cart.addtocart.alreadyincart": "@@PRODUCT@@ 이 이미 장바구니에 있습니다.",
  "cart.addtocart.currencylocked": "장바구니는 현재 @@CURRENCY@@ 로 설정되어 있습니다. 여러 통화를 하나의 주문에 사용하는 것은 불가능합니다. 이 제품을 구매하려면 먼저 @@SHOPPING_CART@@ 을 지우십시오.",
  "cart.addtocart.locked": "장바구니 통화가 @@CURRENCY@@ (으)로 설정되었으며 배송 위치는 @@LOCATION@@ 입니다.",
  "cart.addtocart.shiptolocked": "장바구니가 이미 배송지 \n@@LOCATION@@\n\n로 설정되어 있습니다.이 제품을 구매하려면 먼저 @@SHOPPING_CART@@ 에서 배송지 위치를 변경하세요.",
  "cart.addtocart.success": "@@PRODUCT@@ 이 (가) 장바구니에 추가되었습니다.",
  "cart.empty": "귀하의 장바구니는 현재 비어 있습니다",
  "cart.empty.title": "귀하의 장바구니가 비어 있습니다",
  "cart.gotoproductlist": "제품 목록으로 이동",
  "cart.nolongervalid": "장바구니가 유효하지 않습니다. 계속하려면 업데이트하세요.",
  "cart.recalculate": "다시 계산 ",
  "cart.recalculate.rounding": "요청 된 금액은 포장 단위에 맞게 반올림되었습니다.",
  "cart.removefromcart.success": "@@PRODUCT@@ 이 (가) 장바구니에서 성공적으로 제거되었습니다.",
  "cart.removeproduct": "장바구니에서 @@PRODUCT@@ 을 제거 하시겠습니까?",
  "cart.requestquote": "견적 요청",
  "cart.updatecart": "업데이트",
  "cart.updatecart.success": "@@PRODUCT@@ 이 (가) 장바구니에 추가되었습니다. ",
  "dangerousgoodsclass.1": "폭발물 (1)",
  "dangerousgoodsclass.2.1": "인화성 가스 (2.1)",
  "dangerousgoodsclass.2.2": "불연성 가스 (2.2)",
  "dangerousgoodsclass.2.3": "독성 가스 (2.3)",
  "dangerousgoodsclass.3": "인화성 액체 (3)",
  "dangerousgoodsclass.4.1": "인화성 고체 (4.1)",
  "dangerousgoodsclass.4.2": "인화성 고체 (4.2)",
  "dangerousgoodsclass.4.3": "반응성 물질 (4.3)",
  "dangerousgoodsclass.5.1": "산화 (5.1)",
  "dangerousgoodsclass.6.1": "독성 (6.1)",
  "dangerousgoodsclass.6.2": "생물학적 위험 (6.2)",
  "dangerousgoodsclass.7": "방사성 (7)",
  "dangerousgoodsclass.8": "부식성 (8)",
  "dangerousgoodsclass.9": "기타 (9)",
  "date.invalid": "선택한 날짜가 유효하지 않습니다. ",
  "datefilteroption.last3Months": "지난 3개월",
  "datefilteroption.lastMonth": "지난달",
  "datefilteroption.lastWeek": "지난주",
  "datefilteroption.lastYear": "작년",
  "field.duplicatedphonenumber": "이미 등록된 전화번호입니다. ",
  "field.invalid": "@@VALUE@@ 이 잘못되었습니다.",
  "field.invalidinternalemail": "이메일 주소가 유효하지 않습니다. brenntag.com, brenntag-asia.com 또는 digib.com에서 제공해야 합니다.",
  "field.invalidphonenumber": "전화 번호가 잘못되었습니다. +61212345678 형식을 사용하세요.",
  "field.required": "@@VALUE@@ 은 필수입니다.",
  "filter.accessStatus": "접속 상태",
  "filter.all": "모두",
  "filter.allorders": "전체 주문",
  "filter.allproducts": "전체 제품",
  "filter.apply": "적용하다",
  "filter.brenntagOrderNumber": "Brenntag 주문 번호",
  "filter.compliancerequired": "규정 준수 필수 ",
  "filter.createddate": "작성일 ",
  "filter.customerName": "고객명 ",
  "filter.customerNumber": "고객 번호",
  "filter.customerpo.placeholder": "고객 PO 번호로 필터링",
  "filter.customerponumber": "고객 PO 번호",
  "filter.dangerousgoods": "위험물",
  "filter.deliveryNumber": "배송 번호",
  "filter.deliverydate": "배송 요청 날짜",
  "filter.enddate": "종료일",
  "filter.filterby": "필터",
  "filter.filters": "필터",
  "filter.from": "...에서",
  "filter.hazardous": "위험물",
  "filter.invoicenumber": "인보이스 번호",
  "filter.lastlogindate": "마지막 로그인 날짜",
  "filter.myorders": "내 주문 내역",
  "filter.myproducts": "주문 제품",
  "filter.noresults": "검색 결과가 없습니다",
  "filter.orderdate": "주문일",
  "filter.otherfilters": "기타 필터",
  "filter.pill.accessStatus": "접속 상태",
  "filter.pill.brenntagOrderNumber": "Brenntag 주문 번호",
  "filter.pill.createdDate": "작성일",
  "filter.pill.customerPONumber": "PO 번호",
  "filter.pill.dangerousGoods": "위험물",
  "filter.pill.deliveryDate": "배송 요청 날짜",
  "filter.pill.dueDate": "마감일",
  "filter.pill.hazardousGoods": "위험물",
  "filter.pill.invoiceNumber": "인보이스 번호",
  "filter.pill.issueDate": "인보이스 날짜",
  "filter.pill.lastLoginDate": "로그인 날짜",
  "filter.pill.orderDate": "주문일",
  "filter.pill.packageType": "포장 유형 ",
  "filter.pill.pricePointExists": "제품 가격 ",
  "filter.pill.productName": "상품명",
  "filter.pill.productNumber": "제품 번호",
  "filter.pill.quoteDate": "견적 날짜",
  "filter.pill.requestedDeliveryDate": "배송 요청",
  "filter.pill.resetAll": "필터 재설정",
  "filter.pill.role": "역할",
  "filter.pill.salesGroupId": "영업 조직",
  "filter.pill.searchQuery": "검색",
  "filter.pill.shipToLocationId": "배송지",
  "filter.pill.status": "상태",
  "filter.pill.updatedDate": "업데이트 날짜",
  "filter.pill.userName": "사용자",
  "filter.placeholder.customerName": "고객 이름으로 검색",
  "filter.placeholder.customerNumber": "고객 번호로 검색",
  "filter.placeholder.global": "제품, 주문, 인보이스 검색 ",
  "filter.placeholder.userEmail": "이메일로 검색",
  "filter.placeholder.username": "이름으로 검색",
  "filter.pricePointExists": "제품 가격 ",
  "filter.productName": "상품명",
  "filter.quoteNumber": "견적 번호",
  "filter.quotedate": "견적 날짜",
  "filter.role": "역할",
  "filter.salesRepName": "영업 담당자 이름",
  "filter.salesorganisation": "영업 조직",
  "filter.search-salesorg.placeholder": "고객 또는 회사명으로 검색 ",
  "filter.search.placeholder": "검색 ",
  "filter.shipto": "ship-to ",
  "filter.startdate": "시작일",
  "filter.status": "상태",
  "filter.until": "에",
  "filter.updated": "업데이트",
  "filter.user": "사용자",
  "filter.userEmail": "이메일",
  "filter.userName": "이름",
  "footer.contactus": "문의하기",
  "footer.faqs": "FAQs",
  "footer.privacypolicy": "데이터 및 개인 정보 보호 정책",
  "footer.termsofuse": "이용 약관",
  "home.contact.1": "브랜탁커넥트팀에게 문의하기 ",
  "home.contact.2": "F.A.Q.",
  "home.heading.1": "안녕하세요, @@USERNAME@@",
  "home.heading.2": "Brenntag Connect에 오신 것을 환영합니다!",
  "home.heading.3": "Brenntag Connect는 쉽게 주문하고 최신 정보에 엑세스할 수 있는 온라인 플랫폼입니다.",
  "home.heading.4": "빠른 실행 ",
  "home.invoices.list.1": "인보이스 보기 ",
  "home.invoices.list.2": "인보이스 PDF 다운로드",
  "home.label.explore": "더보기 ",
  "home.label.viewinvoices": "모든 인보이스 보기",
  "home.label.vieworders": "모든 주문 보기",
  "home.orders.list.1": "주문 현황 및 내역 보기",
  "home.orders.list.2": "성적서 다운로드 ",
  "home.products.list.1": "브랜탁 카달로그 검색",
  "home.products.list.2": "SDS/TDS 문서 보기 및 다운로드",
  "home.products.list.3": "제품 주문",
  "home.profile.list.1": "인보이스 데이터 내보내기",
  "home.profile.list.2": "주문 데이터 내보내기",
  "home.profile.list.3": "암호 재설정",
  "home.recent.invoices.due": "최근 만료된 인보이스",
  "home.recent.invoices.issued": "최근 발행된 인보이스",
  "home.recent.orders.created": "최근 작성된 주문",
  "home.recent.orders.updated": "최근 업데이트 주문",
  "invoice.customer": "고객",
  "invoice.date": "발행일",
  "invoice.dueDate": "인보이스 기한",
  "invoice.noinvoicesfound": "아직 인보이스가 발행되지 않았습니다. \n배송이 완료된 후 인보이스를 발행합니다.",
  "invoice.number": "인보이스 번호",
  "invoicestatus.Cancelled": "취소 ",
  "invoicestatus.Open": "진행중 ",
  "invoicestatus.Paid": "지불된 ",
  "invoicestatus.PaidOnline": "온라인 결제",
  "invoicestatus.ProcessingPayment": "결제 처리 ",
  "isolanguage.en": "English",
  "isolanguage.id": "Bahasa Indonesia",
  "isolanguage.ko": "한국어",
  "isolanguage.th": "ไทย",
  "isolanguage.vi": "Tiếng Việt",
  "isolanguage.zh-CN": "中文（簡體）",
  "isolanguage.zh-TW": "中文（繁體）",
  "label.Landline": "유선 전화",
  "label.Mobile": "휴대전화 ",
  "label.additionalinformation": "추가 정보",
  "label.addresses": "주소",
  "label.alternativesizes": "Alternative Sizes",
  "label.amountdue": "총액 ",
  "label.any": "어떤",
  "label.anyquestions": "질문 있어요?",
  "label.batchamount": "총액 ",
  "label.batchnumber": "배치 번호",
  "label.batchsize": "배치 크기",
  "label.billingaddress": "청구지 주소",
  "label.billtoaddress": "청구지 주소",
  "label.billtoaddresses": "청구지 주소",
  "label.billtoaddressincorrect": "주소를 변경하시려면, 채팅을 통해 문의주시기 바랍니다",
  "label.billtoaddressrequired": "청구지 주소가 필요합니다.",
  "label.brenntagordernumber": "Brenntag 주문 번호",
  "label.browseproducts": "제품 찾아보기",
  "label.browseusers": "사용자 찾아보기",
  "label.button.attach": "첨부",
  "label.button.changesalesorg": "예, 영업 조직을 변경합니다.",
  "label.button.editprofile": "내 프로필 편집",
  "label.button.export": "수출",
  "label.button.nokeep": "아니요, 계속합니다. ",
  "label.button.update": "업데이트",
  "label.button.yesterminate": "예, 종료합니다.",
  "label.by": "으로",
  "label.callus": "전화 부탁드립니다. ",
  "label.cancel": "취소",
  "label.category": "카테고리",
  "label.changepassword": "암호 재설정",
  "label.changesalesorg": "영업 조직 변경",
  "label.changesalesorgwarning": "영업 조직을 변경하시겠습니까?",
  "label.checkingavailability": "재고 확인중 ",
  "label.clickheretoreview": "검토하려면 여기를 클릭하십시오.",
  "label.comments": "비고 ",
  "label.company": "회사",
  "label.confirmeddeliveryamount": "주문 수량 확인 ",
  "label.continueshopping": "쇼핑을 계속하다",
  "label.country": "국가",
  "label.creationdate": "작성일 ",
  "label.creditnote": "Credit note ",
  "label.customer": "고객",
  "label.customername": "고객명 ",
  "label.customernumber": "고객 번호",
  "label.customerponumber": "고객 PO 번호",
  "label.customerporeference": "고객 발주 번호 ",
  "label.customerporeferencemaxlength": "고객 발주 번호는 @@LENGTH@@자를 초과 할 수 없습니다.",
  "label.customerporeferencerequired": "고객 발주 번호가 필요합니다.",
  "label.dangerousgoodsclass": "위험물 등급",
  "label.dangerousgoodscode": "DG",
  "label.datedelivered": "배송 날짜",
  "label.datefrom": "Date from ",
  "label.dateissued": "발행일",
  "label.dateto": "Date to ",
  "label.debitnote": "Debit note ",
  "label.defaultlanguage": "언어",
  "label.delete": "삭제 ",
  "label.deliverynumber": "배송 번호",
  "label.details": "세부 정보 ",
  "label.discountperpack": "팩당 할인",
  "label.distributionchannel": "유통 채널",
  "label.division": "Division ",
  "label.documents": "문서 다운로드",
  "label.dontshowthis": "다시 표시하지 않음 ",
  "label.download.all": "모두 다운로드",
  "label.download.pdf": "PDF 다운로드",
  "label.editmode": "편집 모드",
  "label.email": "이메일 주소",
  "label.emailaddress": "이메일 주소",
  "label.exportdata": "데이터 내보내기",
  "label.exporting": "데이터를 내보내는 중입니다. 잠시만 기다려주세요 ...",
  "label.exportingerror": "파일을 내보내는 중에 오류가 발생했습니다. 다시 시도하십시오.",
  "label.exportinglonger": "여전히 내보내기를 생성 중입니다. 몇 분 정도 걸릴 수 있습니다.",
  "label.exportingsuccess": "데이터 파일을 성공적으로 내보냈습니다.",
  "label.exportordersinvoicescsv": "주문 및 인보이스의 데이터를 CSV 또는 Excel (XLSX) 파일로 직접 내 보냅니다.",
  "label.exportselectcategory": "내보내기 파일의 카테고리와 날짜 범주를 선택하십시오.",
  "label.externaluserfile": "외부 사용자 파일",
  "label.filesattached": "첨부 파일",
  "label.from": "From: ",
  "label.fullname": "성명",
  "label.hazardousgoodscode": "HZ",
  "label.hazchem": "HazChem",
  "label.internaluserfile": "내부 사용자 파일",
  "label.invoice": "인보이스",
  "label.invoice.status.Cancelled": "취소 ",
  "label.invoice.status.Open": "진행중 ",
  "label.invoice.status.Paid": "지불된 ",
  "label.invoice.status.PaidOnline": "온라인 결제",
  "label.invoice.status.ProcessingPayment": "결제",
  "label.item": "Item",
  "label.items": "Items ",
  "label.language": "언어",
  "label.lastlogin": "마지막 로그인",
  "label.learn_more_about_brenntag": "Brenntag Connect 에 대해 자세히 알아보기",
  "label.logout": "로그아웃 ",
  "label.minimumquantity": "최소 수량",
  "label.myprofile": "My profile ",
  "label.name": "성명",
  "label.next-step": "다음 단계",
  "label.no": "아니요 ",
  "label.no-filesattached": "첨부된 파일이 없습니다. ",
  "label.no-filesuploaded": "업로드 된 파일이 없습니다.",
  "label.none": "없음",
  "label.nopriceavailable": "가격 없음 ",
  "label.notes": "Notes ",
  "label.orderNumber": "주문 번호",
  "label.orderamount": "주문 수량",
  "label.orderamount.zero": "주문 수량은 0 일 수 없습니다. 장바구니에서 제품을 제거 할 수 있습니다.",
  "label.orderdate": "주문일",
  "label.orderdetails": "주문 정보",
  "label.orderfiles": "주문 파일",
  "label.orderlist": "주문 목록",
  "label.ordervalue": "주문 금액",
  "label.pack": "포장 ",
  "label.packaging": "포장",
  "label.packaginginformation": "포장 정보",
  "label.packinggroup": "포장 그룹",
  "label.packsize": "포장 크기",
  "label.packtype": "포장 유형 ",
  "label.paymentreference": "Payment reference ",
  "label.paymentterms": "결제 조건",
  "label.payonline": "온라인 결제",
  "label.personalinfo": "사용자 정보",
  "label.phonenumber": "전화 번호",
  "label.placeorder": "주문하기",
  "label.placingorder": "주문하기",
  "label.preferences": "Preferences ",
  "label.previous-step": "이전 단계",
  "label.price": "가격",
  "label.priceperpack": "팩당 가격",
  "label.pricesareexclusiveofsurcharges": "가격에는 추가 요금이나 세금이 포함되어 있지 않습니다.",
  "label.pricesaresubjecttochange": "가격은 변경 될 수 있습니다.",
  "label.productname": "상품명",
  "label.productnumber": "제품 번호",
  "label.products": "제품 ",
  "label.producttype": "상품 유형",
  "label.profile": "프로필",
  "label.purchaseOrderNumber": "고객 PO 번호",
  "label.quantity": "수량",
  "label.quantity.minimumorderamount": "금액은 @@MINIMUMORDERAMOUNT@@ 보다 크거나 같아야합니다.",
  "label.quantity.minimumorderquantity": "수량은 @@MINIMUMORDERQUANTITY@@ 보다 크거나 같아야합니다.",
  "label.quantity.tiereddiscounts": "수량 할인 가능",
  "label.quantity.toolarge": "값이 너무 큽니다.",
  "label.quantity.zero": "값은 0보다 커야합니다.",
  "label.quotedate": "견적 날짜",
  "label.quotenumber": "견적 번호",
  "label.records": "Items ",
  "label.redirecttoadmin": "관리자 인터페이스로 이동",
  "label.remove": "제거하다",
  "label.removeproduct": "제품 제거",
  "label.reorder": "재주문하기 ",
  "label.reorderall": "전체 재주문하기  ",
  "label.requestcancellation": "취소 요청 ",
  "label.requestedamount": "요청 금액",
  "label.requesteddeliverydate": "배송 요청 날짜",
  "label.requesteddeliverydate.tooltip": " Brenntag 팀의 재고 및 확인 내용에 따라, 배송일은 항상 변경 될 수 있습니다. ",
  "label.requesteddeliverydate.warning": "Brenntag 팀의 재고 및 확인 내용에 따라 달라질 수 있습니다. ",
  "label.requesteddeliverydaterequired": "배송 요청일을 입력 해 주세요. ",
  "label.requestquote": "견적 요청",
  "label.retry": "다시 해 보다",
  "label.role": "역할",
  "label.role.Admin": "관리자",
  "label.role.CSR": "CSR",
  "label.role.ReadUser": "사용자 읽기",
  "label.role.SuperAdmin": "최고 관리자",
  "label.role.User": "사용자 ",
  "label.role.UserAdmin": "관리자",
  "label.role.UserManager": "관리자",
  "label.salesorganisation": "영업 조직",
  "label.scheduleddeliverydate": "배송 예정일",
  "label.selectpaymentmethod": "결제 방법 선택",
  "label.selectsalesorganisation": "영업 조직 선택",
  "label.shelflife": "유통 기한",
  "label.shippinginstructions": "배송 요청사항 ",
  "label.shipto": "배송지",
  "label.shiptoaddress": "배송지 주소",
  "label.shiptoaddresses": "배송지 주소",
  "label.shiptoaddressincorrect": "배송지 선택에 따라 판매가가 달라질 수 있습니다. 배송지를 잘 선택해 주시고, 잘못된 경우 채팅을 통해 문의하십시오.",
  "label.shiptoaddressrequired": "배송지 주소가 필요합니다.",
  "label.shoppingcart": "장바구니",
  "label.size": "크기",
  "label.soldtoaddress": "판매처 주소",
  "label.sortby": "정렬 기준",
  "label.specifications": "스펙 ",
  "label.statusacknowledged": "확인",
  "label.statusclosed": "완료",
  "label.statusopen": "진행중 ",
  "label.storageconditions": "보관 조건",
  "label.subtotal": "소계",
  "label.tab.attachedfiles": "첨부 파일",
  "label.tab.attachnew": "첨부하기 ",
  "label.tax": "세금",
  "label.temperatureconditions": "온도 조건",
  "label.termsandconditions": "이용 약관",
  "label.timezone": "Time zone ",
  "label.total": "합계",
  "label.type": "유형",
  "label.unitprice": "단가",
  "label.unnumber": "UN number ",
  "label.updated": "업데이트",
  "label.user": "사용자 ",
  "label.validfrom": "~로부터 유효",
  "label.validto": "까지 유효하다",
  "label.viewquote": "견적보기",
  "label.viewvideos": "동영상 보기 ",
  "label.yes": "예",
  "label.yourproductnumber": "귀사 제품 번호",
  "languageselection.modal.areyousure": "언어를 변경하시겠습니까?",
  "languageselection.modal.confirm": "예, 언어를 변경하겠습니다. ",
  "languageselection.modal.description": "언어를 변경하면 Brentag Connect의 모든 이메일과 모든 사용자 인터페이스에 영향을 미칩니다.",
  "languageselection.modal.title": "기본 언어 변경",
  "location.shipto.notavailable": "이 제품은 선택한 배송처에 배송할 수 없습니다. 배송처를 변경 하십시오. ",
  "logout.changeswillbelost": "로그 아웃하면 이 페이지의 변경 사항이 사라집니다. ",
  "logout.confirmlogout": "계속하시겠습니까?",
  "logout.itemsinyourshoppingcartcanbelost": "로그 아웃하면 장바구니에있는 항목이 사라질 수 있습니다. ",
  "message.accessrestricted": "수행하려는 작업에 엑세스 권한이 없는 것 같습니다. 관리자에게 문의하십시오. ",
  "message.admincsrredirect": "엑세스 권한이 초과하여 잘못된 위치에 접속 되었습니다. ",
  "message.areyousure": "확실한가요?",
  "message.changesalesorg": "영업 조직을 변경하면 제품 카탈로그, 주문 목록, 견적, 인보이스 및 Brenntag Connect의 장바구니에 담긴 모든 제품에 영향을 미칩니다. 필요 시 다시 변경할 수 있습니다.",
  "message.changeswillbelost": "이 페이지의 변경 사항이 사라집니다. ",
  "message.documentnotfound": "문서가 중복 또는 손상되어 에러가 발생했습니다. 새 문서를 다운로드 할 수 없습니다. ",
  "message.noitemstoshow": "표시 할 항목이 없습니다.",
  "message.noprices": "이 제품의 가격은 채팅으로 문의하십시오.",
  "message.pagenotfound": "이 페이지가 누락 된 것 같습니다.",
  "message.productnaforshipto": "견적 요청시 배송처를 선택 할 수 없습니다. 다른 것을 선택하십시오.",
  "order.cancelmodal.button": "주문 취소 요청",
  "order.cancelmodal.question": "다음 주문을 취소 하시겠습니까?",
  "order.cancelmodal.questionfollowup": "취소 요청 후에는 작업을 되돌릴 수 없습니다.",
  "order.cancelmodal.title": "주문 취소 요청",
  "order.cancelmodal.title.poabbr": "PO",
  "order.coadocument": "CoA 문서",
  "order.confirmationdocument": "주문 확정",
  "order.history.batch": "배치 ",
  "order.history.batch_amount": "총액 ",
  "order.history.bill_to": "청구지 ",
  "order.history.comment_from_user": "비고 ",
  "order.history.deliveryNumber": "배송 번호",
  "order.history.delivery_date": "배송 날짜",
  "order.history.delivery_information": "배송 정보",
  "order.history.hide": "숨김 ",
  "order.history.missing_productname": "제품 이름을 사용할 수 없습니다.",
  "order.history.nologs": "이 주문에 대한 기록이 없습니다.",
  "order.history.number": "번호",
  "order.history.orderDetails": "주문 세부 정보",
  "order.history.orderStatus": "주문 상태",
  "order.history.order_amount": "주문 수량 ",
  "order.history.payment_terms": "결제 조건",
  "order.history.pricing_unit_value": "단가",
  "order.history.quantity_calculated": "수량",
  "order.history.requested_delivery_date": "배송 요청 날짜",
  "order.history.ship_to": "ship-to ",
  "order.history.shipping_instructions": "배송 요청사항 ",
  "order.history.show": "보기 ",
  "order.history.sold_to": "판매처",
  "order.history.status": "상태",
  "order.history.subtotal_value": "소계",
  "order.history.title": "주문 기록 ",
  "order.history.total_value": "총액",
  "order.invoice.download": "인보이스 다운로드",
  "order.invoice.title": "인보이스",
  "order.invoice.titlePlural": "인보이스",
  "order.invoice.view": "보기",
  "order.requestchange.allorderlinesdeleted": "품을 선택해야 주문이 생성됩니다. 주문 취소는 ‘취소요청’을 선택하거나 채팅을 통해 문의주시기 바랍니다.",
  "order.requestchange.close": "완료 ",
  "order.requestchange.closeeditmode": "편집 모드 닫기",
  "order.requestchange.closeeditmodeconfirmation": "예, 편집 모드를 닫습니다. ",
  "order.requestchange.closewarning": "변경 요청을 종료 하시겠습니까?",
  "order.requestchange.discardedwarning": "이 주문에 대한 저장되지 않은 모든 변경 사항은 사라집니다.",
  "order.requestchange.leavewarning": "이 페이지에서 나가시겠습니까?",
  "order.requestchange.placechangerequest": "장소 변경 요청",
  "order.requestchange.productnotavailable": "더 이상  제품 또는 가격에 대한 변경 요청을 할 수 없습니다. 채팅으로 문의하십시오.",
  "order.requestchange.requestchange": "변경 요청",
  "order.requestchange.shiptoaddressnotavailable": "이 주문에 배송지 주소를 사용할 수 없습니다. 다른 배송지 주소를 선택하거나 채팅으로 문의 해주세요.",
  "order.requestchange.shiptoaddressnotavailablewarning": "배송지 주소를 사용할 수 없습니다.",
  "order.status.Acknowledged": "확인",
  "order.status.Cancelled": "취소 ",
  "order.status.Closed": "완료",
  "order.status.Confirmed": "확정 ",
  "order.status.Invoiced": "청구완료 ",
  "order.status.Open": "진행중 ",
  "order.status.OutForDelivery": "배송 예정",
  "order.status.Submitted": "제출 됨",
  "order.success.message": "귀하의 주문은 현재 Brenntag 팀에서 확인 중입니다. 확인이 완료되면 배송 정보 확인서가 발송 됩니다. 질문이 있거나 변경 사항이 있으시면 채팅으로 문의하십시오. \n",
  "order.success.title": "주문이 완료되었습니다. ",
  "page.AccessRestricted": "액세스 제한",
  "page.CustomerList": "고객",
  "page.Home": "홈",
  "page.InvoiceList": "인보이스",
  "page.NotFound": "페이지를 찾을 수 없음 (404)",
  "page.OrderList": "주문",
  "page.PaymentInvoice": "온라인 결제",
  "page.ProductList": "제품 ",
  "page.Profile": "My profile ",
  "page.QuoteList": "견적",
  "page.SearchResultsFor": "검색 결과",
  "page.TermsAndConditions": "이용 약관",
  "page.TermsOfUse": "이용 약관-Brenntag Connect",
  "page.UserList": "사용자 ",
  "paymentInvoice.error": "인보이스를 검색 할 수 없습니다. 페이지를 새로 고침하고 다시 시도하세요.",
  "paymentInvoice.infoCard.credit": "Credit ",
  "paymentInvoice.infoCard.creditcardStoreInfo": "Brenntag는 고객의 신용 카드 정보를 저장하지 않습니다.",
  "paymentInvoice.infoCard.debitNote": "Debit note ",
  "paymentInvoice.infoCard.downloadpdf": "PDF 다운로드",
  "paymentInvoice.infoCard.invoice": "인보이스",
  "paymentInvoice.infoCard.price": "가격",
  "paymentInvoice.infoCard.review": "확인하려면 클릭하십시오.",
  "paymentInvoice.infoCard.terms": "이용 약관",
  "paymentRedirect.error.heading": "문제가 발생했습니다",
  "paymentRedirect.error.subtitle": "다시 시도하거나 채팅으로 문의하십시오.",
  "paymentRedirect.error.title": "결제 중에 오류가 발생하여 인보이스 /  전표가 결제되지 않았습니다.",
  "paymentRedirect.invoiceList": "인보이스 목록",
  "paymentRedirect.invoiceNumber": "인보이스 번호",
  "paymentRedirect.paidAmount": "지불 금액",
  "paymentRedirect.paymentReference": "Payment reference ",
  "paymentRedirect.pending.heading": "보류 ",
  "paymentRedirect.pending.subtitle": "Brenntag 팀에서 결제가 확인되면 주문 상태가 업데이트됩니다.",
  "paymentRedirect.pending.title": "지급 업체의 확인을 위해 결제가 보류 중입니다.",
  "paymentRedirect.refused.heading": "결제 거부",
  "paymentRedirect.refused.subtitle": "다른 결제 방법을 사용하여 다시 시도하십시오.",
  "paymentRedirect.refused.title": "결제가 거부되었습니다. ",
  "paymentRedirect.success.heading": "감사합니다",
  "paymentRedirect.success.subtitle": "인보이스가 결제되었습니다. Brenntag 팀은 결제를 처리하고 인보이스 상태를 업데이트합니다.",
  "paymentRedirect.success.title": "결제가 완료되어 처리 중입니다.",
  "paymentterms.A001": "120 DAYS FROM INV DD, BY 15TH",
  "paymentterms.A002": "15 DAYS FROM INV DD, BY 25T",
  "paymentterms.A003": "15 DAYS FROM INV DD, BY 5TH",
  "paymentterms.A004": "30 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A005": "30 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A006": "30 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A007": "30 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A008": "45 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A009": "45 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A010": "60 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A011": "60 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A012": "60 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A013": "60 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A014": "75 DAYS FROM INV DATE, BY EOM",
  "paymentterms.A015": "90 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A016": "90 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A017": "90 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A018": "90 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A019": "60 DAYS FROM INV DATE, BY 26TH",
  "paymentterms.A020": "45 DAYS FROM INV DATE BY 10TH",
  "paymentterms.A021": "0-10:20,11-20:EoM,>=21 NxtM10",
  "paymentterms.A022": "INV 26-10:PAY 14,11-25: PAY 28",
  "paymentterms.A023": "CUT OFF 20TH, PAY ON 28TH",
  "paymentterms.A024": "45D FR INV;PAY 2ND/12TH/22ND",
  "paymentterms.A025": "45D (CUT-OFF 25TH) BY 15TH",
  "paymentterms.A026": "150D FROM INV DATE, PAY 25TH",
  "paymentterms.B004": "4 DAYS FROM INV DATE",
  "paymentterms.B005": "5 DAYS FROM INV DATE",
  "paymentterms.B007": "7 DAYS FROM INV DATE",
  "paymentterms.B009": "9 DAYS FROM INV DATE",
  "paymentterms.B010": "10 DAYS FROM INV DATE",
  "paymentterms.B013": "13 DAYS FROM INV DATE",
  "paymentterms.B014": "14 DAYS FROM INV DATE",
  "paymentterms.B015": "15 DAYS FROM INV DATE",
  "paymentterms.B018": "18 DAYS FROM INV DATE",
  "paymentterms.B020": "20 DAYS FROM INV. DATE",
  "paymentterms.B021": "21 DAYS FROM INV DATE",
  "paymentterms.B022": "22 DAYS FROM INV DATE",
  "paymentterms.B028": "28 DAYS FROM INV DATE",
  "paymentterms.B029": "29 DAYS FROM INV DATE",
  "paymentterms.B030": "30 DAYS FROM INV DATE",
  "paymentterms.B037": "37 DAYS FROM INV DATE",
  "paymentterms.B038": "38 DAYS FROM INV DATE",
  "paymentterms.B040": "40 DAYS FROM INV DATE",
  "paymentterms.B045": "45 DAYS FROM INV DATE",
  "paymentterms.B050": "50 DAYS FROM INV DATE",
  "paymentterms.B055": "55 DAYS FROM INV DATE",
  "paymentterms.B060": "60 DAYS FROM INV DATE",
  "paymentterms.B065": "65 DAYS FROM INV DATE",
  "paymentterms.B068": "68 DAYS FROM INV DATE",
  "paymentterms.B070": "70 DAYS FROM INV DATE",
  "paymentterms.B075": "75 DAYS FROM INV DATE",
  "paymentterms.B080": "80 DAYS FROM INV DATE",
  "paymentterms.B085": "85 DAYS FROM INV. DATE",
  "paymentterms.B090": "90 DAYS FROM INV DATE",
  "paymentterms.B105": "105 DAYS FROM INV DATE",
  "paymentterms.B120": "120 DAYS FROM INV DATE",
  "paymentterms.B150": "150 DAYS FROM INV DATE",
  "paymentterms.B180": "180 DAYS FROM INV DATE",
  "paymentterms.B360": "360 DAYS FROM INV DATE",
  "paymentterms.BA01": "50% ADV, BALANCE 30 DAYS INV",
  "paymentterms.BA02": "30% ADV, BALANCE 30 DAYS INV",
  "paymentterms.BA03": "60% ADV, 40% PDC UPON DEL 30D",
  "paymentterms.BA04": "30%TT ADV AND 70 % TT AT SIGHT",
  "paymentterms.BA05": "30%TT ADV AND 70 % DP AT SIGHT",
  "paymentterms.BA06": "80% TT ADV AND 20% TT AT SIGHT",
  "paymentterms.BA07": "20% TT ADV 80% DP AT SIGHT",
  "paymentterms.BA08": "28% TT ADV 72% 60D FR INV DATE",
  "paymentterms.BA09": "70% TT ADV 30% DP AT SIGHT",
  "paymentterms.BA10": "50% TT ADV 50% DP AT SIGHT",
  "paymentterms.BA11": "20% TT ADV 80% TT AT SIGHT",
  "paymentterms.BA12": "40% Advance, 60% B/L date",
  "paymentterms.BA13": "50% Advance, 50% BL date",
  "paymentterms.BA14": "50% ADV, BALANCE 45 DAYS INV",
  "paymentterms.BA15": "50% ADV BAL 45 DAYS BL DATE",
  "paymentterms.BA16": "50% TT ADV, 50 % LC AT SIGHT",
  "paymentterms.BA17": "50% ADV, 50% At SIGHT B/L COPY",
  "paymentterms.BA18": "70% TT ADV, 30% TT AT SIGHT",
  "paymentterms.BA19": "20% TT ADVANCE 80% COD",
  "paymentterms.BA20": "30% DP,70% after 60 days B/L",
  "paymentterms.BA21": "50% ADV, 50% AT SIGHT INV DATE",
  "paymentterms.BA22": "50% Advance 50% Immediate",
  "paymentterms.BA23": "70% TT AT SIGHT,30% TT 75 DAYS",
  "paymentterms.BA24": "50% TT ADV, 50% TT AT SIGHT",
  "paymentterms.BA25": "30% ADV, 70% BL DATE",
  "paymentterms.BA26": "10% DEP AGST PI, 90% TT@SIGHT",
  "paymentterms.BA27": "10% TT ADV, 90% DP AT SIGHT",
  "paymentterms.BA28": "15% TT ADV, 85% DP AT SIGHT",
  "paymentterms.BA29": "40% ADV, BAL COD",
  "paymentterms.BA30": "30% TT ADV, 70% 30D AFT B/L",
  "paymentterms.BA31": "90% CASH IN ADV, 10% TT 90DAYS",
  "paymentterms.BA32": "50% TT ADV, 50% TT 15D FR B/L",
  "paymentterms.BA33": "50% TT ADV, 50% 30D AFT B/L",
  "paymentterms.BA34": "60% ADV, 40% PDC UPON DEL 30D",
  "paymentterms.BA35": "50% ADV/50% 60DAYS FROM INVDAY",
  "paymentterms.BADV": "ADV PAYMENT",
  "paymentterms.BB05": "5 DAYS FROM BL DATE",
  "paymentterms.BB07": "7 DAYS FROM BL DATE",
  "paymentterms.BB10": "10 DAYS FROM BL DATE",
  "paymentterms.BB14": "14 DAYS FROM BL DATE",
  "paymentterms.BB15": "15 DAYS FROM BL DATE",
  "paymentterms.BB20": "20 DAYS FROM BL DATE",
  "paymentterms.BB21": "21 DAYS FROM BL DATE",
  "paymentterms.BB30": "30 DAYS FROM BL DATE",
  "paymentterms.BB35": "35 DAYS FROM BL DATE",
  "paymentterms.BB38": "38 DAYS FROM BL DATE",
  "paymentterms.BB40": "40 DAYS FROM BL DATE",
  "paymentterms.BB45": "45 DAYS FROM BL DATE",
  "paymentterms.BB46": "LC 45 DAYS FROM BL DATE",
  "paymentterms.BB50": "50 DAYS FROM BL DATE",
  "paymentterms.BB60": "60 DAYS FROM BL DATE",
  "paymentterms.BB65": "65 DAYS FROM BL DATE",
  "paymentterms.BB70": "70 DAYS FROM BL DATE",
  "paymentterms.BB75": "75 DAYS FROM BL DATE",
  "paymentterms.BB85": "85 DAYS FROM BL DATE",
  "paymentterms.BB90": "90 DAYS FROM BL DATE",
  "paymentterms.BB97": "97 DAYS FROM BL DATE",
  "paymentterms.BB98": "98 DAYS FROM BL DATE",
  "paymentterms.BB99": "99 DAYS FROM BL DATE",
  "paymentterms.BCBD": "CASH BEFORE DELIVERY",
  "paymentterms.BCOD": "CASH ON DELIVERY",
  "paymentterms.BD01": "D/A 15 DAYS FROM B/L DATE",
  "paymentterms.BD02": "D/A 30 DAYS FROM B/L DATE",
  "paymentterms.BD03": "D/A 45 DAYS FROM B/L DATE",
  "paymentterms.BD04": "D/A 60 DAYS FROM B/L DATE",
  "paymentterms.BD05": "D/A 75 DAYS FROM B/L DATE",
  "paymentterms.BD06": "D/A 90 DAYS FROM B/L DATE",
  "paymentterms.BD07": "D/A 120 DAYS FROM B/L DATE",
  "paymentterms.BD12": "DOC AGNST ACCEPTANCE 120 DAYS",
  "paymentterms.BD15": "DOC AGNST ACCEPTANCE 15 DAYS",
  "paymentterms.BD30": "DOC AGNST ACCEPTANCE 30 DAYS",
  "paymentterms.BD45": "DOC AGNST ACCEPTANCE 45 DAYS",
  "paymentterms.BD60": "DOC AGNST ACCEPTANCE 60 DAYS",
  "paymentterms.BD75": "DOC AGNST ACCEPTANCE 75 DAYS",
  "paymentterms.BD90": "DOC AGNST ACCEPTANCE 90 DAYS",
  "paymentterms.BDAA": "DOCUMENTS AGNST ACCEPTANCE",
  "paymentterms.BDAP": "DOC AGNST ACCEPTANCE AT SIGHT",
  "paymentterms.BE00": "0 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.BE14": "15 DAYS FR INV DD, EOM BY 20TH",
  "paymentterms.BE15": "15 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE16": "15 DAYS EOM",
  "paymentterms.BE20": "20DAYS FR INV DD, EOM BY 20TH",
  "paymentterms.BE21": "20 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE22": "20 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE23": "20 DAYS EOM BY 25TH",
  "paymentterms.BE30": "30 DAYS EOM BY 20TH",
  "paymentterms.BE31": "EOM BY 25TH",
  "paymentterms.BE32": "32 days end of month by 2nd",
  "paymentterms.BE33": "60 days end of month by 2nd",
  "paymentterms.BE45": "45 DAYS EOM",
  "paymentterms.BE60": "60 DAYS EOM",
  "paymentterms.BE61": "60 DAYS EOM BY 20TH",
  "paymentterms.BE62": "60 DAYS EOM BY 15TH",
  "paymentterms.BE63": "60 days end of month by 4th",
  "paymentterms.BE90": "90 DAYS EOM",
  "paymentterms.BE91": "90 DAYS EOM BY 5TH",
  "paymentterms.BIMM": "IMMEDIATE",
  "paymentterms.BL15": "LC 15 DAYS AT SIGHT",
  "paymentterms.BL21": "LC 21 DAYS AT SIGHT",
  "paymentterms.BL30": "LC 30 DAYS AT SIGHT",
  "paymentterms.BL45": "LC 45 DAYS AT SIGHT",
  "paymentterms.BL60": "LC 60 DAYS AT SIGHT",
  "paymentterms.BL61": "LC 60 DAYS BL",
  "paymentterms.BL75": "LC 75 DAYS AT SIGHT",
  "paymentterms.BL90": "LC 90 DAYS AT SIGHT",
  "paymentterms.BL91": "LC 90 DAYS BL",
  "paymentterms.BLAS": "LC PAYMENT AT SIGHT",
  "paymentterms.BP12": "DOCUMENTS AGNST PAYTS 120 DAYS",
  "paymentterms.BP30": "DOCUMENTS AGNST PAYTS 30 DAYS",
  "paymentterms.BP60": "DOCUMENTS AGNST PAYTS 60 DAYS",
  "paymentterms.BPAA": "D/P AT SIGHT",
  "paymentterms.BTAS": "TT AT SIGHT",
  "paymentterms.CAD1": "CASH AGAINST DOCUMENT",
  "paymentterms.CBO1": "CBO",
  "paymentterms.CBO2": "30% CBO, 70% CBD",
  "paymentterms.CBO3": "50% CBO, 50% CBD",
  "paymentterms.CBO4": "50% CBO, 50% COD",
  "paymentterms.CBO5": "50% CBO, 50% 30 DAYS FROM INV",
  "paymentterms.CNMT": "CNMT - CONSIGNMENT",
  "paymentterms.D001": "TT AGAINST DOCUMENT",
  "paymentterms.D002": "TT IN ADVANCE",
  "paymentterms.D004": "TT EOM 30D BY 20TH FRM BL DD",
  "paymentterms.D005": "TT 30 DAYS FROM INVOICE DATE",
  "paymentterms.D006": "TT 45 DAYS FROM BL DATE",
  "paymentterms.D007": "TT 45 DAYS FROM INV DATE",
  "paymentterms.D008": "TT 60 DAYS FROM INVOICE DATE",
  "paymentterms.D010": "TT 65 DAYS FROM  B/L Date",
  "paymentterms.D011": "TT 25 DAYS FROM INVOICE DATE",
  "paymentterms.D012": "TT AGAINST BL",
  "paymentterms.D013": "7 DAYS T/T AT SIGHT",
  "paymentterms.D014": "T/T BEFORE DELIVERY",
  "paymentterms.D015": "TT UPON ORDER CONFIRMATION",
  "paymentterms.D016": "TT 2 DAYS FROM INVOICE DATE",
  "paymentterms.D017": "TT 90 DAYS FROM INVOICE DATE",
  "paymentterms.DD01": "DIRECT DEBIT 30 DAYS",
  "paymentterms.DD02": "DIRECT DEBIT 60 DAYS",
  "paymentterms.DD03": "DIRECT DEBIT 90 DAYS",
  "paymentterms.E001": "EOM 30 DAYS BY 10TH",
  "paymentterms.E002": "EOM 30 DAYS BY 15TH",
  "paymentterms.E003": "EOM 30 DAYS BY 20TH",
  "paymentterms.E004": "EOM 30 DAYS BY 25TH",
  "paymentterms.E005": "EOM 60 DAYS BY 10TH",
  "paymentterms.E006": "EOM 60 DAYS BY 15TH",
  "paymentterms.E007": "EOM 60 DAYS BY 20TH",
  "paymentterms.E008": "EOM 60 DAYS BY 25TH",
  "paymentterms.E009": "EOM 90 DAYS BY 10TH",
  "paymentterms.E010": "EOM 90 DAYS BY 15TH",
  "paymentterms.E011": "EOM 90 DAYS BY 20TH",
  "paymentterms.E012": "EOM 90 DAYS BY 25TH",
  "paymentterms.E013": "EOM",
  "paymentterms.E014": "EOM 30 DAYS",
  "paymentterms.E015": "EOM 30 DAYS BY 5th",
  "paymentterms.E016": "EOM 30 DAYS BY 10th",
  "paymentterms.E017": "EOM 30D BY 20th",
  "paymentterms.E018": "EOM 30D BY 25th",
  "paymentterms.E019": "EOM 30 DAYS (CUT-OFF 25th)",
  "paymentterms.E020": "EOM 30D (CUT-OFF 25th) BY 5TH",
  "paymentterms.E021": "EOM 30D (CUT-OFF 25th) BY 10TH",
  "paymentterms.E022": "EOM 45 DAYS (CUT-OFF 25th)",
  "paymentterms.E023": "EOM 60 DAYS",
  "paymentterms.E024": "EOM 60 DAYS BY 5th",
  "paymentterms.E025": "EOM 60 DAYS BY 10th",
  "paymentterms.E026": "EOM 60 DAYS BY 15th",
  "paymentterms.E027": "EOM 60 DAYS (CUT-OFF 25th)",
  "paymentterms.E028": "EOM 60D (CUT-OFF 25th) BY 5TH",
  "paymentterms.E029": "EOM 60D (CUT-OFF 25th) BY 10TH",
  "paymentterms.E030": "EOM 90 DAYS",
  "paymentterms.E031": "EOM 90 DAYS BY 7TH",
  "paymentterms.E032": "EOM 90 DAYS (CUT-OFF 20th)",
  "paymentterms.E033": "EOM 90 DAYS (CUT-OFF 25th)",
  "paymentterms.E034": "EOM BY 5TH",
  "paymentterms.E035": "EOM BY 10TH",
  "paymentterms.E036": "EOM 30D (CUT-OFF 20th) BY 15TH",
  "paymentterms.E037": "EOM 90D (CUT-OFF 25th) by 7th",
  "paymentterms.E038": "EOM 45 DAYS (CUT-OFF 25) BY 5",
  "paymentterms.E039": "EOM 60 DAYS (CUT-OFF 20th)",
  "paymentterms.E040": "EOM 90 DAYS (CUT-OFF 25) BY 8",
  "paymentterms.E041": "EOM 60 DAYS (CUT-OFF 25th) 15",
  "paymentterms.E042": "EOM 90 DAYS (CUT-OFF 25th) 5th",
  "paymentterms.E043": "EOM 90 DAYS (CUT-OFF 25th) 10",
  "paymentterms.E044": "EOM 90 DAYS (CUT-OFF 25th)15",
  "paymentterms.E045": "EOM 90 DAYS (CUT-OFF 25th)20th",
  "paymentterms.E046": "EOM 120 DAYS(CUT-OFF 25th)15th",
  "paymentterms.E047": "EOM 30 DAYS (CUT-OFF 25th)15th",
  "paymentterms.E048": "DUE SAME DAY NEXT MTH",
  "paymentterms.E049": "EOM 30 DAYS (DUE ON 27TH)",
  "paymentterms.E050": "EOM 60 DAYS DUE 25th",
  "paymentterms.E051": "EOM 210D",
  "paymentterms.E052": "EOM 105D",
  "paymentterms.E053": "EOM 60 DAYS (CUT-OFF 20TH) 20",
  "paymentterms.E054": "EOM 30 DAYS (CUT-OFF  20th)",
  "paymentterms.E055": "EOM 30D (CUT_OFF 25TH) BY 16TH",
  "paymentterms.E056": "EOM 85D (CUT-OFF 25TH)",
  "paymentterms.E057": "EOM 90D (DUE 5TH FOLLOWING)",
  "paymentterms.E058": "EOM 120D",
  "paymentterms.E059": "EOM (CUT-OFF 25TH) BY 5TH",
  "paymentterms.E060": "EOM 45 DAYS BY 15TH",
  "paymentterms.E061": "64 DAYS FROM EOM",
  "paymentterms.E062": "EOM BY 10TH",
  "paymentterms.E063": "EOM BY 26TH",
  "paymentterms.E064": "EOM 31 days",
  "paymentterms.E065": "EOM 50 DAYS (CUT-OFF 24th)",
  "paymentterms.E120": "120 DAYS EOM",
  "paymentterms.EA65": "65 DAYS ETA",
  "paymentterms.EM15": "EOM 15 DAYS",
  "paymentterms.EM20": "EOM 20 DAYS",
  "paymentterms.EM30": "30 DAYS EOM",
  "paymentterms.EM45": "EOM 45 DAYS",
  "paymentterms.EM65": "EOM 65 DAYS",
  "paymentterms.EM75": "EOM 75 DAYS",
  "paymentterms.EQ01": "End of Quarter (by 20th)",
  "paymentterms.GR10": "10 DAYS AFTER GOODS RECEIPT",
  "paymentterms.GR30": "30 DAYS AFTER GOODS RECEIPT",
  "paymentterms.IK00": "Within 5 days 3% cash discount",
  "paymentterms.L001": "LC 150 DAYS AT SIGHT",
  "paymentterms.L002": "LC 180 DAYS AT SIGHT",
  "paymentterms.L003": "LC 105 DAYS BL",
  "paymentterms.L004": "LC 120 DAYS BL",
  "paymentterms.L005": "LC 150 DAYS BL",
  "paymentterms.L006": "LC 180 DAYS BL",
  "paymentterms.L007": "LC 15 DAYS BL",
  "paymentterms.L030": "LC 30 DAYS BL",
  "paymentterms.L105": "105 DAYS FROM BL DATE",
  "paymentterms.L120": "120 DAYS FROM BL DATE",
  "paymentterms.L150": "150 DAYS FROM BL DATE",
  "paymentterms.L180": "L 180 DAYS FROM BL DATE",
  "paymentterms.LD01": "LAST DAY NEXT MTH",
  "paymentterms.LD02": "LAST DAY OF MTH AFT NEXT MTH",
  "paymentterms.LD03": "LAST DAY OF THREE MONTH LATER",
  "paymentterms.LVT0": "16 days 2%, 31 days net",
  "paymentterms.M001": "3 MONTH LATER BY 5TH",
  "paymentterms.M002": "3 MONTH LATER BY 5TH",
  "paymentterms.MVT0": "10 days 3%, 16  2%, 31 net",
  "paymentterms.P001": "60 DAYS ETA",
  "paymentterms.P002": "90 DAYS ETA",
  "paymentterms.P003": "15 DAYS FROM ETA HCM PORT",
  "paymentterms.P004": "60 DAYS FROM ETA, PAY ON 26TH",
  "paymentterms.PBD1": "PDC BEFORE DEL 30 DAYS",
  "paymentterms.PBD2": "PDC BEFORE DEL 45 DAYS",
  "paymentterms.PBD3": "PDC BEFORE DEL 60 DAYS",
  "paymentterms.PBD4": "PDC BEFORE DEL 90DAYS FROM INV",
  "paymentterms.PBD5": "PDC BEFORE DEL 15 DAYS",
  "paymentterms.PDC1": "30 DAYS PDC FROM INV DATE",
  "paymentterms.PDC2": "60 DAYS PDC FROM INV DATE",
  "paymentterms.PDC3": "45 DAYS PDC FROM INV DATE",
  "paymentterms.PDC4": "15 DAYS PDC FROM INV DATE",
  "paymentterms.PDC5": "90 DAYS PDC FROM INV DATE",
  "paymentterms.PUD1": "PDC UPON DEL 15 DAYS FROM INV",
  "paymentterms.PUD2": "PDC UPON DEL 30 DAYS FROM INV",
  "paymentterms.PUD3": "PDC UPON DEL 45 DAYS FROM INV",
  "paymentterms.PUD4": "PDC UPON DEL 60 DAYS FROM INV",
  "paymentterms.PUD5": "PDC UPON DEL 90 DAYS FROM INV",
  "paymentterms.TX07": "7 DAYS AFTER STOCK ARRIVAL",
  "paymentterms.TX30": "30 DAYS DECLARATION",
  "paymentterms.TX45": "45 DAYS DECLARATION",
  "paymentterms.TX60": "60 DAYS DECLARATION",
  "paymentterms.TX90": "90 DAYS DECLARATION",
  "paymentterms.WALL": "99% forever",
  "paymentterms.WL01": "12 days net",
  "paymentterms.Z001": "custom payment term (test)",
  "paymentterms.ZB00": "Pay immediately w/o deduction",
  "paymentterms.ZB01": "14 Days 3%, 30/2%, 45 net",
  "paymentterms.ZB02": "8 days 5%, 14/2%, 21 net",
  "paymentterms.ZB03": "20 days 2%, 30 days net",
  "paymentterms.ZB04": "10 days 4%, 20/2%, 30 net",
  "paymentterms.ZB05": "5 days 2%, 10 days net",
  "phone.landline": "유선 전화",
  "phone.mobile": "휴대 전화",
  "product.altsizes.loadmore": "더 많은 대체 사이즈 로드 ",
  "product.discount.saveamount": "@@AMOUNT@@ 저장",
  "product.discount.savingspercentage": "@@PERCENTAGE@@ 절감",
  "product.documentType.msds": "SDS 문서",
  "product.documentType.tds": "TDS 문서",
  "product.documenterror": "문서를 검색할 수 없습니다.",
  "product.loadingdocuments": "문서 로드",
  "product.nodocuments": "사용 가능한 문서 없음",
  "product.safetyinformation": "안전 정보",
  "product.type.nonvaluated": "Non-Valuated Materials",
  "product.type.packaging": "포장",
  "product.type.returnable": "반품 가능 패키지",
  "product.type.sample": "Sample ",
  "product.type.services": "서비스",
  "product.type.tolling": "Tolling ",
  "product.type.tolling-raw-material-nonvaluated": "Tolling raw material non-valuated",
  "product.type.tradinggoods": "무역 상품",
  "quote.date": "견적 날짜",
  "quote.decline": "견적 거부",
  "quote.details": "견적 세부 정보",
  "quote.number": "견적 번호",
  "quote.requoteproduct": "제품 재 견적",
  "quote.validfrom": "부터 유효하다 ",
  "quote.validto": "까지 유효하다",
  "quote.value": "견적 값",
  "quotestatus.Declined": "거부된 ",
  "quotestatus.Expired": "만료된",
  "quotestatus.InProgress": "진행중",
  "quotestatus.Open": "진행중 ",
  "quotestatus.Ordered": "주문된 ",
  "quotestatus.Submitted": "제출된 ",
  "quotestatus.Upcoming": "예정",
  "regex.placeordertermsandconditions": "주문하면 @@TERMS_AND_CONDITIONS@@ 에 동의하게됩니다.",
  "regex.reviewtermsandconditions": "@@TERMS_AND_CONDITIONS@@ 를 검토하려면 여기를 클릭하십시오.",
  "requestcancellation.request": "Brenntag 고객 서비스 팀, 주문 번호 : @@ORDER_NUMBER@@ 및 고객 번호 : @@CUSTOMER_NUMBER@@ 로 주문 취소를 요청하고 싶습니다. 필요에 따라 확인 또는 추가 정보를 제공하십시오.",
  "requestchanges.message.billToAddress": "-이전 청구 주소 : \n@@LOCATION_OLD@@\n\n-새 청구 주소 : \n@@LOCATION_NEW@@",
  "requestchanges.message.cancelproduct": "-제품 취소 : \n\n제품 : @@PRODUCT_NAME@@ \n제품 ID : @@PRODUCT_NUMBER@@",
  "requestchanges.message.comments": "-비고 : \n@@COMMENTS_OLD@@ → @@COMMENTS_NEW@@",
  "requestchanges.message.deliverydate": "-배송 요청 일 : \n@@DATE_OLD@@ → @@DATE_NEW@@",
  "requestchanges.message.heading": "Brenntag 고객 서비스 팀, 주문에 대한 다음 정보를 변경해 주시겠습니까? \n\n고객 번호 @@CUSTOMER_NUMBER@@ \n주문 번호 @@PURCHASE_ORDER_NUMBER@@\n\n---------",
  "requestchanges.message.orderline": "-제품 변경 : \n\n제품 : @@PRODUCT_NAME@@ \n제품 ID : @@PRODUCT_NUMBER@@\n-수량 : @@QUANTITY_OLD@@ → @@QUANTITY_NEW@@\n-수량 : @@AMOUNT_OLD@@ @@MOUNT_UOM_OLD@@ → @@AMOUNT_NEW@@ @@AMOUNT_UOM_NEW@@",
  "requestchanges.message.shipToAddress": "-이전 배송지 : \n@@LOCATION_OLD@@\n\n-새 배송지 : \n@@LOCATION_NEW@@",
  "requestquote.request": "Brenntag 고객 서비스 팀, 다음에 대한 견적을 요청 드립니다. \n\n고객 번호 @@CUSTOMER_NUMBER@@ \n\n제품 : @@PRODUCT_NAME@@ \n\n제품 ID : @@PRODUCT_NUMBER@@ \n\n요청 수량 : @@QUANTITY@@ \n\n요청 금액 : @@REQUESTED_AMOUNT@@\n\n배송 주소 : \n@@SHIP_TO_ADDRESS@@ \n\n배송 요청 날짜 : @@REQUESTED_DELIVERY_DATE@@",
  "show_more.less": "작게 보기 ",
  "show_more.more": "자세히보기",
  "show_more.results": "더 많은 결과 표시",
  "something.wrong": "이런! 문제가 발생했습니다. 다시 시도하십시오",
  "something.wrong.documents": "이런! 문제가 발생했습니다",
  "sortinglabel.-currency": "Currency (Z-A)",
  "sortinglabel.-customerName": "고객 이름 (ZA)",
  "sortinglabel.-dueDate": "최근 마감일 ",
  "sortinglabel.-grossAmount.amount": "최고 미수금  ",
  "sortinglabel.-invoiceNumber": "인보이스 번호 (Z-A)",
  "sortinglabel.-issueDate": "최신 발행 날짜",
  "sortinglabel.-lastLoggedInAt": "마지막 로그인",
  "sortinglabel.-lastUpdateDate": "최신 업데이트",
  "sortinglabel.-name": "제품명 (Z-A)",
  "sortinglabel.-netAmount": "최고 금액",
  "sortinglabel.-orderCreationDate": "최신 주문 날짜",
  "sortinglabel.-packaging.name": "포장 유형 (Z-A)",
  "sortinglabel.-quoteCreationDate": "최신 견적 날짜",
  "sortinglabel.-username": "이름 (Z-A)",
  "sortinglabel.-usertype": "사용자 유형 (외부 우선)",
  "sortinglabel.currency": "Currency (A-Z)",
  "sortinglabel.customerName": "고객 이름 (A-Z)",
  "sortinglabel.dueDate": "가장 오래된 ",
  "sortinglabel.grossAmount.amount": "최저 미수금 ",
  "sortinglabel.invoiceNumber": "인보이스 번호 (A-Z)",
  "sortinglabel.issueDate": "가장 오래된 발행일 ",
  "sortinglabel.lastLoggedInAt": "가장 오래된 로그인 ",
  "sortinglabel.lastUpdateDate": "가장 오래된 업데이트",
  "sortinglabel.name": "제품명 (A-Z)",
  "sortinglabel.netAmount": "최저 금액",
  "sortinglabel.orderCreationDate": "가장 오래된 주문 날짜",
  "sortinglabel.packaging.name": "포장 유형 (A-Z)",
  "sortinglabel.quoteCreationDate": "가장 오래된 견적일",
  "sortinglabel.relevance": "적합성",
  "sortinglabel.username": "이름 (A-Z)",
  "sortinglabel.usertype": "사용자 유형 (내부 우선)",
  "storageconditions.01": "실온 보관-식품, 제약",
  "storageconditions.02": "실온 보관",
  "storageconditions.03": "위험물 보관",
  "storageconditions.04": "냉장 보관-식품, 제약",
  "storageconditions.05": "가연성 ",
  "storageconditions.06": "냉장 보관",
  "storageconditions.07": "냉동 보관",
  "storageconditions.08": "불소 보관 ",
  "storageconditions.09": "암모니아 보관 ",
  "storageconditions.10": "Non-conforming Storage",
  "storageconditions.11": "Liquid Bulk Storage",
  "storageconditions.12": "생산 지역",
  "support.email": "support@brenntagconnect.com",
  "support.email.salesgroup.NL01": "orders.au@brenntag-asia.com",
  "support.email.topic": "문의 : {customer PO#}/ {quotation #}/ {customer ID}",
  "support.phonenumber": "+123 3453 043",
  "temperatureconditions.01": "> 25 ~ 40ºC",
  "temperatureconditions.02": "습도 > 15 ~ 25ºC",
  "temperatureconditions.03": "습도 > 8 ~ 15ºC",
  "temperatureconditions.04": "습도 > 0 ~ 8ºC",
  "temperatureconditions.05": "> -20 ~ 0ºC",
  "temperatureconditions.06": "-20ºC 이하",
  "terms.agree": "네, 동의합니다. ",
  "terms.description": "귀하는 Brenntag Connect에 엑세스 또는 일부 서비스를 이용함으로써 본 이용 약관에 동의하게 됩니다. \n\n본 계약의 모든 이용 약관에 동의하지 않는 경우 Brentag Connect에 액세스하거나 해당 서비스를 사용할 수 없습니다.",
  "terms.disagree": "아니요, 로그 아웃합니다.",
  "timeunit.many.day": "일",
  "timeunit.many.month": "개월",
  "timeunit.many.week": "주",
  "timeunit.many.year": "년",
  "timeunit.one.day": "일",
  "timeunit.one.month": "달",
  "timeunit.one.week": "주",
  "timeunit.one.year": "년",
  "toast.error.coadocuments": "CoA 문서를 검색하는 중에 문제가 발생했습니다.",
  "toast.error.createuser": "사용자 계정 생성에 문제가 발생했습니다.",
  "toast.error.customernotfound": "문제가 발생했습니다. Brenntag Connect에 문의하십시오.",
  "toast.error.customers": "고객을 검색하는 중에 문제가 발생했습니다.",
  "toast.error.invoices": "인보이스 데이터를 검색하는 중에 문제가 발생했습니다.",
  "toast.error.languagechange": "언어 변경 실패",
  "toast.error.orderdetails": "주문 내역을 검색하는 중에 문제가 발생했습니다.",
  "toast.error.orders": "주문 내역을 검색하는 중에 문제가 발생했습니다.",
  "toast.error.placingorder": "주문 중에 문제가 발생했습니다.",
  "toast.error.price": "가격을 검색 중에 문제가 발생했습니다.",
  "toast.error.productdocuments": "제품 문서 검색 중에 문제가 생겼습니다.",
  "toast.error.products": "제품 데이터 검색 중에 문제가 발생했습니다.",
  "toast.error.quote": "견적 정보를 검색하는 중에 문제가 발생했습니다.",
  "toast.error.quotereject": "견적을 거부하는 중에 문제가 발생했습니다.",
  "toast.error.quotes": "견적 검색 중에 문제가 발생했습니다.",
  "toast.error.saveuser": "사용자 변경 사항을 저장하는 중에 문제가 발생했습니다.",
  "toast.error.userinfo": "사용자 정보를 검색하는 중에 문제가 발생했습니다.",
  "toast.error.userservice": "사용자 데이터를 검색하는 중에 문제가 발생했습니다.",
  "toast.error.userservice.emailaddressexists": "이미 @@EMAIL@@ 인 사용자가 존재합니다.",
  "toast.error.userservice.permissionsoutsidesalesgroup": "담당 영업 부서 외에 사용자를 만들거나 수정할 수 없습니다.",
  "toast.error.userservice.savefailed": "사용자 데이터를 저장하는 중에 문제가 발생했습니다.",
  "toast.error.validatingcart": "장바구니 확인 중에 문제가 발생했습니다.",
  "toast.success.createuser": "@@USER@@ 계정이 성공적으로 생성되었습니다.",
  "toast.success.deleteuser": "@@USER@@ 계정이 성공적으로 삭제되었습니다.",
  "toast.success.resetpassword": "비밀번호를 재설정하기 위해 @@EMAIL@@ 이메일을 보냈습니다.",
  "toast.success.saveuser": "@@USER@@ 계정이 성공적으로 저장되었습니다.",
  "user.accessrights": "접근 권한 및 언어",
  "user.accessrights.message": "고객에게 액세스를 허용하다",
  "user.bcaccessstatus": "Brenntag Connect 접속 상태",
  "user.create": "사용자 생성",
  "user.createdon": "에 만든",
  "user.delete.confirmation": "이 작업은 취소 할 수 없습니다. 계속 하시겠습니까?",
  "user.delete.message": "사용자 @@USER@@ 은 영구적으로 삭제됩니다.",
  "user.edit": "사용자 수정",
  "user.information": "사용자 정보",
  "user.lastpasswordreset": "최근 비밀번호 재설정",
  "user.modal.terminate.confirmation": "이 사용자를 종료하시겠습니까?",
  "user.modal.terminate.message": "경고: 종료된 사용자는 더 이상 Brenntag Connect에 로그인할 수 없습니다.",
  "user.notes": "노트",
  "user.notes.placeholder": "예 : 근무 시간 정보, 백업 연락처",
  "user.role": "역할",
  "user.save": "변경 사항을 저장하다",
  "user.search.customer": "고객 번호 또는 이름 검색",
  "user.selectcustomer": "고객 선택",
  "user.selectlanguage": "언어 선택",
  "user.view": "사용자보기",
  "userEdit.cancel.confirm": "취소 하시겠습니까?",
  "userEdit.cancel.create.external": "'외부 사용자 만들기'취소",
  "userEdit.cancel.create.internal": "'내부 사용자 만들기'취소",
  "userEdit.cancel.edit.external": "'외부 사용자 편집'취소",
  "userEdit.cancel.edit.internal": "'내부 사용자 편집'취소",
  "userEdit.message.cannotedit": "이 사용자 정보는 편집할 수 없습니다. 사용자 정보변경은 Brenntag에 문의하시기 바랍니다.",
  "userrole.Admin": "관리자",
  "userrole.CSR": "CSR",
  "userrole.ReadUser": "읽기 전용 사용자",
  "userrole.SuperAdmin": "최고 관리자",
  "userrole.User": "사용자 ",
  "userrole.UserAdmin": "관리자",
  "userrole.UserManager": "사용자 관리자",
  "userrole.description": "사용자 역할",
  "validationerror.invalid-date": "선택한 날짜가 유효하지 않습니다. ",
  "validationerror.invalid-moq": "선택한 금액이 최소 주문 수량보다 적습니다.",
  "validationerror.not-authorized": "승인되지 않음",
  "validationerror.not-found": "이 상품은 존재하지 않습니다",
  "validationerror.price-changed": "이 제품의 가격이 업데이트되었습니다.",
  "validationerror.price-mismatch": "일부 가격이 업데이트되었습니다.",
  "validationerror.price-not-found": "이 제품에 대한 가격을 찾을 수 없습니다. 가격을 요청하려면 채팅으로  문의하십시오.",
  "validationerror.uom-mismatch": "이 제품의 UOM이 일치하지 않습니다.",
  "video.invoices": "인보이스",
  "video.invoices.description": "Brenntag Connect에서 인보이스를 검색하고 다운로드하는 방법에 대해 알아보십시오.",
  "video.ordering": "주문 및 재주문",
  "video.ordering.description": "Brenntag Connect에서 주문 및 재주문하는 방법에 대해 알아보십시오.",
  "video.orderlist": "주문 목록보기",
  "video.orderlist.description": "Brenntag Connect에서 주문 내역을 보는 방법에 대해 알아보십시오.",
  "video.productsearch": "제품 검색",
  "video.productsearch.description": "Brenntag Connect에서 제품을 검색하는 방법에 대해 알아보십시오."
} as const
